import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import {MobileDeviceConfiguration } from './Pages';

export const MobileDeviceConfig = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={MobileDeviceConfiguration} />
       
    </Fragment>
)